module.exports = __webpack_public_path__ + "img/PL08267.56d5f509.png";